import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { staticColumnWidth } from './column-width-utils';
import { CatalogItemValue } from 'app/modules/data/models/catalog';
import { SelectOptionMobile } from '@shared/models/catalog.service';

@Pipe({
  name: 'staticTableWidth'
})
export class StaticTableWidthPipe implements PipeTransform {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public transform(
    staticColumns: SelectOptionMobile[],
    data: CatalogItemValue[],
    fileColumnNames: string[],
    breakPointScreen: 0 | 1 | 2 | 3 | 4 | 5,
  ): string {
    const allColumnsWidth = (staticColumns || []).reduce((width, column, index) => {
      const columnWidth = staticColumnWidth(data, column, fileColumnNames, index === 1, breakPointScreen) || 0;
      width += columnWidth;
      return width;
    }, 0);
    const staticTableWith = Math.min(allColumnsWidth, 500);
    const margin = breakPointScreen === 5 ? 50 : 0;
    this.document.documentElement.style.setProperty('--static-table-min-width', `${ staticTableWith + margin }px`);
    return `${ staticTableWith + margin }px`;
  }
}
